/**
* Dashboard JS
* -----------------------------------------------------------------------------
*
* All the JS for the Dashboard component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'dashboard',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( document ).ready( function() {
        // Preloader
        preloaderFadeOutTime = 500;
        function hidePreloader() {
          const preloader = $( '#loading-screen' );
          preloader.fadeOut( preloaderFadeOutTime );
        }
        hidePreloader();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'dashboard', COMPONENT );
} )( app );
